/* eslint-disable quotes */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
// react
import React, { useState } from "react";

// third-party
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { MyApiUrl } from "../services/service";
// import { Link } from 'react-router-dom';

// application
// import StroykaSlick from '../shared/StroykaSlick';

// data stubs
import theme from "../../data/theme";

const mystyle = {
    card: {
        backgroundColor: "#e4e1ff",
        borderRadius: 10,
        padding: 20,
        width: "100%",
    },
    card1: {
        backgroundColor: "#e1f1ff",
        borderRadius: 10,
        padding: 20,
        width: "100%",
    },
};

function SitePageAboutUs() {
    const [AboutUs, setAboutUs] = useState("");
    const [Mission, setMission] = useState("");
    const [Vission, setVission] = useState("");
    const [Philosophy, setPhilosophy] = useState("");
    const GetAboutUs = () => {
        axios({
            method: "GET",
            url: MyApiUrl + "About",
            headers: {
                "content-type": "application/json",
            },
        })
            .then((response) => {
                console.log(response.data);
                setAboutUs(response.data[0].about_us);
                setMission(response.data[0].about_mission);
                setVission(response.data[0].about_vision);
                setPhilosophy(response.data[0].about_philosophy);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    React.useEffect(() => {
        GetAboutUs();
    }, []);
    return (
        <div className="block about-us">
            <Helmet>
                <title>{`About Us — ${theme.name}`}</title>
            </Helmet>

            <div
                className="about-us__image"
                style={{
                    background: "#e7e7e7",
                }}
            />
            <div className="container">
                <div className="row justify-content-center">
                    <div
                        className="col-12 col-xl-10"
                        style={{
                            borderLeft: "1px solid rgb(210 210 210)",
                            borderRight: "1px solid rgb(210 210 210)",
                            padding: "0 15px",
                        }}
                    >
                        <div className="about-us__body">
                            <h1 className="about-us__title">About Us</h1>
                            <h3 className="about-us__team-title" style={{ textAlign: "left", color: "#ff862e" }}>
                                AFGHAN DRY FRUIT
                            </h3>
                            <div className="about-us__text typography">
                                <div
                                    dangerouslySetInnerHTML={{ __html: AboutUs }}
                                    style={{
                                        textAlign: "justify",
                                        wordBreak: "break-word",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12 col-md-6 mb-3">
                                <div style={mystyle.card}>
                                    <h4
                                        className="about-us__team-title"
                                        style={{ textAlign: "left", color: "#ff862e" }}
                                    >
                                        VISION
                                    </h4>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: Vission }}
                                        style={{ textAlign: "justify" }}
                                    />
                                </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                                <div style={mystyle.card1}>
                                    <h4
                                        className="about-us__team-title"
                                        style={{ textAlign: "left", color: "#ff862e" }}
                                    >
                                        MISSION
                                    </h4>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: Mission }}
                                        style={{ textAlign: "justify" }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className="about-us__body"
                            style={{
                                marginTop: "0px",
                                padding: "30px",
                                minHeight: "280px",
                                borderBottom: "1px solid rgb(210 210 210)",
                            }}
                        >
                            <div className="about-us__team">
                                <h2 className="about-us__team-title" style={{ textAlign: "left", color: "#ff862e" }}>
                                    OUR PHILOSOPHY
                                </h2>
                                <div className="about-us__text typography">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: Philosophy }}
                                        style={{ textAlign: "justify" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SitePageAboutUs;
